import Vue from 'vue';
import store from './../../store';
import billTransformer from './../../transformers/bill';
import paginationTransformer from '../../transformers/pagination';
import helpers from '../../utils/helpers';

const success = ({ data }, resolve) => {
  const bills = billTransformer.fetchCollection(data.data);
  const pagination = paginationTransformer.fetch(data.pagination);

  store.dispatch('fetchPaginatedBills', { bills, pagination });
  resolve({ bills, pagination });
};

const failed = (error, reject) => reject(error);


export default (params = {}) => (
  new Promise((resolve, reject) => {
    Vue.$http.get(helpers.buildUrl('/bills', params))
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/bill/items.js